// extracted by mini-css-extract-plugin
export default {"loginImages":"LoginImages_loginImages__K2dpc","loginNikuHere":"LoginImages_loginNikuHere__lxO8V","loginNikuLogo":"LoginImages_loginNikuLogo__fBHdz"};